<template>
  <div class="site">
    <common-layout>
      <div slot="header">
        <h3>消息中心</h3>
      </div>
      <div slot="container">
        <div class="search">
          <el-input
            placeholder="请输入内容"
            v-model="pageVO.keyword"
            class="input-with-select"
            @keyup.enter.native="search"
            clearable
            @clear="search"
            style="width:240px"
          >
            <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
          </el-input>
          <!-- <label style="line-height:40px">消息类型</label>
          <el-select
            style="width:140px"
            v-model="pageVO.msgType"
            clearable
            placeholder="全部"
            @change="search"
          >
            <el-option
              v-for="item in fieldOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select> -->
          <label style="line-height:40px;margin-left: 30px;">状态</label>
          <el-select
            style="width:140px"
            v-model="pageVO.readFlag"
            clearable
            placeholder="全部"
            @change="search"
          >
            <el-option
              v-for="item in stateValue"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <div class="base-table">
          <el-table
            ref="multipleTable"
            :data="tableData"
            style="width: 100%"
            :header-cell-style="{ background: '#E5F3FE', color: '#623AA2' }"
            class="table"
          >
            <el-table-column type="index" width="150" label="序号" align="center">
              <template slot-scope="scope">
                <span>{{ scope.$index + (pageVO.page - 1) * pageVO.pageSize + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column label="消息内容" align="center" prop="title"></el-table-column>
            <!-- <el-table-column label="消息类型" align="center" prop="msgType">
              <template slot-scope="scope">
                {{ fieldOptions.filter(el =>el.value === scope.row.msgType)[0].label }}
              </template>
            </el-table-column> -->
            <el-table-column label="消息时间" align="center" prop="sendTime"></el-table-column>
            <el-table-column label="状态" align="center" prop="readFlag">
              <template slot-scope="scope">
                <el-tag type="danger" v-if="scope.row.readFlag === 0">未读</el-tag>
                <el-tag type="success" v-else>已读</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button
                  class="mini_btn"
                  type="text"
                  @click="handleDetail(scope.$index, scope.row)"
                >
                  详情
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <div class="pagination">
            <div class="grid-content bg-purple-light">
              <el-pagination
                @current-change="handleCurrentChange"
                style="text-align:left;margin:20px 0"
                layout="total, prev, pager, next,jumper"
                :total="total"
                :current-page.sync="pageVO.page"
                :page-size="pageVO.pageSize"
              ></el-pagination>
            </div>
          </div>
        </div>
        <el-dialog
          :visible.sync="pitchViset"
          width="30%"
          class="site.dialog"
          :modal-append-to-body="true"
          :append-to-body="true"
          :close-on-click-modal="false"
          title="消息详情"
        >
          <div style="padding: 0 30px;" v-if="pitchViset">
            <h3>{{ pitch.title }}</h3>
            <p style="margin-top: 30px; text-align: left; line-height: 30px;">
              {{ pitch.message ? '原因：' + pitch.message : '' }}
            </p>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="xqclone">关闭</el-button>
          </span>
        </el-dialog>
      </div>
    </common-layout>
  </div>
</template>

<script>
import CommonLayout from '../../components/common-layout.vue';
export default {
  components: { CommonLayout },
  data() {
    return {
      searchValue: null,
      fieldOptions: [
        { label: '企业信息', value: 1 },
        { label: '企业经营信息', value: 2 },
        { label: '融资需求', value: 3 },
        { label: '担保需求', value: 4 },
        { label: '投资需求', value: 5 },
        { label: '金融产品发布', value: 6 },
        { label: '金融产品申请', value: 7 },
        { label: '金融产品推荐,', value: 8 },
        { label: '企业推荐', value: 9 },
        { label: '融资需求-反馈信息', value: 10 },
      ],
      stateValue: [
        { label: '未读', value: 0 },
        { label: '已读', value: 1 },
      ],
      tableData: [],
      total: 0,
      pitch: null,
      pitchViset: false,
      pageVO: {
        keyword: null,
        readFlag: null,
        // msgType:null,
        page: 1,
        pageSize: 10,
      }
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.http
        .post(this.urlConfig.devUrl + 'apij2/admin-api/finance/mail/page', this.pageVO)
        .then(res => {
          if (res.code == 0) {
            this.tableData = res.data.data;
            this.total = res.data.total;
          }
        });
    },
    // 搜索
    search() {
      this.pageVO.page = 1;
      this.getData();
    },
    // 翻页
    handleCurrentChange() {
      this.getData();
    },
    // 详情
    handleDetail(index, item) {
      this.http.post(this.urlConfig.devUrl + 'apij2/admin-api/finance/mail/updateState', {
        userId: JSON.parse(this.$store.getters.userInfo).id,
        title: item.title,
        message: item.message,
        sendTime: item.sendTime,
        readFlag: 1,
        id: item.id,
      });
      this.pitch = item;
      this.pitchViset = true;
    },
    xqclone(){
      this.pitchViset = false;
      this.$store.dispatch("getnewsList")
      this.getData();
    }
  },
};
</script>
<style lang="scss">
@include component(site) {
  height: 100%;
  width: 100%;
  @include component(search) {
    width: 100%;
    text-align: left;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    /deep/.el-input--suffix {
      width: 100%;
    }
    .el-input {
      // width: 400px;
      margin: 0 15px;
    }
    .date-picker {
      margin: 0 15px;
      .el-range-separator {
        width: auto;
      }
    }
  }
  .base-table {
    width: 100%;
    margin-top: 20px;
    border: 1px solid #eef1f6;
  }
  @include part(dialog) {
    text-align: center;
    .el-dialog__header {
      background: #f47227;
      padding: 0;
      height: 50px;
      color: #fff;
      line-height: 50px;
      .el-dialog__title {
        color: #fff;
      }
      .el-dialog__headerbtn .el-dialog__close {
        color: #fff;
      }
    }
  }
}
</style>
